/**
 * Atalho para o Cenário do PCP a partir das listas da página (clientes do
 * período, atrasados). O valor é `abrir({pedido, cliente})` para quem tem
 * `capacidade_fabrica:reprogramar` e `null` para os demais: sem a permissão
 * o atalho não aparece (especificação F2.4).
 *
 * Contexto em vez de prop porque as listas ficam três componentes abaixo da
 * página; passar a função de mão em mão acoplaria todos eles ao cenário.
 */
import { createContext, useContext } from "react";

export const ReprogramarContext = createContext(null);

export function useAbrirCenario() {
  return useContext(ReprogramarContext);
}
